module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_gampel_bratsch_jpg-158a4550e069b0e595f40c48658d968a.png";